export type BootstrapSize = 'lg' | 'md' | 'sm' | 'xl' | 'xs';
export type BootstrapColor =
    | 'danger'
    | 'dark'
    | 'default'
    | 'info'
    | 'light'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning';

const maxWidthMediaQuery = (maxWidth: number): string => `@media (max-width: ${maxWidth}px)`;
const minWidthMediaQuery = (minWidth: number): string => `@media (min-width: ${minWidth}px)`;

const custom = {
    max: maxWidthMediaQuery,
    min: minWidthMediaQuery,
};

export type ColumnWidth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type ShadowOptions =
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24;

/**
 * These are the breakpoints for bootstrap
 */
export type ScreenSize = 'lg' | 'md' | 'sm' | 'xl' | 'xs';

export const breakpoints: Record<ScreenSize, number> = {
    lg: 1200,
    md: 992,
    sm: 768,
    xl: 1440,
    xs: 0,
};

export const screenSize: Record<ScreenSize, string> & { custom: typeof custom } = {
    custom,
    /* Large devices (laptops/desktops, 1200px and up) */
    lg: minWidthMediaQuery(breakpoints.lg),
    /* Medium devices (landscape tablets, 992px and up) */
    md: minWidthMediaQuery(breakpoints.md),
    /* Small devices (portrait tablets and large phones, 768px and up) */
    sm: minWidthMediaQuery(breakpoints.sm),
    /* Extra large devices (large laptops and desktops, 1440px and up) */
    xl: minWidthMediaQuery(breakpoints.xl),
    /* Extra small devices (phones, 768px and down) */
    xs: maxWidthMediaQuery(breakpoints.sm),
};
